<template>
  <div>
    <tree-search-tree @update:is-add-new-menu-active="updateActive"
                      v-if="$route.params.id === undefined"/>
    <entity-list ref="listContainer"
                 v-if="$route.params.id === undefined"
                 :is-add-new-active="isAddNewActive"
                 :form-config="formConfig"
    />

    <entity-edit v-else-if="$route.params.id !== undefined"
                 :entity-id="$route.params.id"
                 :form-config="formConfig"
    />
  </div>
</template>
<script>
import {TreeConfig, PropertyConfig, FieldType, Filter, Operator} from '../../common/index.d.ts'
import EntityList from '../../common/EntityList'
import EntityEdit from '../../common/EntityEdit'


import {ref} from '@vue/composition-api'
import {useRouter} from '@core/utils/utils'
import store from '@/store'
import TreeSearchTree from '../menu-group/TreeSearchTree'

export default {
  components: {
    EntityList,
    EntityEdit,
    TreeSearchTree,
  },

  setup(props, {refs}) {
    const router = useRouter().route;
    let entityId = undefined
    try {
      entityId = router.value.params.id
    } catch (e) {
      console.log(e)
    }
    const isAddNewActive = ref(false);
    console.log("init with value menu group " + entityId)
    let father = ref(0)

    let arr = [
      new PropertyConfig("id", "Id", FieldType.TEXT),
      new PropertyConfig("name", "Name", FieldType.TEXT),
      new PropertyConfig("title", "Title", FieldType.TEXT),
      new PropertyConfig("father_id", "Parent", FieldType.HIDE).withDefaultValue(father),
      new PropertyConfig("menu_group_id", "MenuGroupId", FieldType.HIDE).withDefaultValue(ref(entityId)),
      new PropertyConfig("channel_id", "Channel", FieldType.SELECT).withAction("app-cms/fetchChannels"),
      new PropertyConfig("css_class", "CssClass", FieldType.TEXT),
      new PropertyConfig("link", "Link", FieldType.TEXT),
      new PropertyConfig("rank_order", "Sequence", FieldType.NUMBER),
    ];
    let formConfig = new TreeConfig(undefined, arr, "menu").withRootAction(`app-cms/getMenuRoot`,
        {"id": entityId}).withSearchName("name")


    const updateActive = (res) => {
      refs.listContainer.openAddNew({
        "parent_id": res.id,
      })
      /**
       * this will update  the value for child
       */
      father.value = res.id

    }

    return {
      entityId,
      updateActive,
      isAddNewActive,
      formConfig,
    }
  },
}
</script>


<style lang="scss">
@import "@core/scss/vue/libs/tree.scss";
</style>
